import React from 'react';

export default class Page9 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>NEXT STEPS</div>
                                            <p style={{paddingBottom: '8px !important'}}>By now, you should have
                                                one (or more) motivation ‘webs’ on the chart. You can use these
                                                to:</p>

                                            <ol className="brownbullet-list contentnumberspacing spaceadd nextstep-st">
                                                <li>
                                                    <div className=" bulletpara"><p>Identify any ‘highs’ and
                                                        ‘lows’ for yourself and others, and note how these
                                                        insights could contribute to your own management, team
                                                        contribution and other work-related subjects.</p></div>
                                                </li>
                                                <li>
                                                    <div className=" bulletpara"><p>Identify any differences (or
                                                        consistencies) within your team and consider their
                                                        implications for the way you work together.</p></div>
                                                </li>
                                                <li>
                                                    <div className=""><p>Act as a starting point for discussing
                                                        your performance management targets and the best way to
                                                        achieve them.</p></div>
                                                </li>

                                            </ol>

                                            <p>Use the following table, and the information you collected on the
                                                previous pages, to consider ways to motivate your team (or
                                                whoever else you choose), according to their ‘motivators’ as
                                                identified in their individual webs:</p>
                                            <div className="desktop ipad-portrait-show">
                                                <table className="ilead_v_sport tablesrink para-bottompad"
                                                       border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" align="left" valign="center"
                                                            width="10%">Motivational area
                                                        </th>
                                                        <th align="left" valign="top" width="45%">High (4-5)
                                                        </th>
                                                        <th colSpan="4" className=" green_curve1" align="left"
                                                            valign="top" width="45%">Low (1-2)
                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="center"
                                                            width="10%">
                                                            <div className="paddingcenter4"><span
                                                                className="subtitle-table"><strong>Achieve</strong></span>
                                                            </div>
                                                        </td>

                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="45%">
                                                            <ul className="greenbullet-list">
                                                                <li>High sense of urgency</li>
                                                                <li>May become frustrated and impatient</li>
                                                                <li> Likes to compete with others</li>
                                                                <li>Sets demanding targets for self and others
                                                                </li>
                                                                <li className="list-bottom-pad"> Doesn’t take
                                                                    failure well
                                                                </li>
                                                            </ul>
                                                            <p>Consider setting them ambitious targets.
                                                                Encourage them to talk to you before they get
                                                                frustrated or irritated.</p>

                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="45%">
                                                            <ul className="greenbullet-list">
                                                                <li> Low sense of urgency</li>
                                                                <li>May not be focused on high quality levels
                                                                </li>
                                                                <li> Collaborates with others</li>
                                                                <li className="list-bottom-pad"> Does not mind
                                                                    making mistakes
                                                                </li>

                                                            </ul>
                                                            <p>Ensure you clarify priorities and outline the
                                                                implications of mistakes. Encourage them to work
                                                                with others.</p>

                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="center"
                                                            width="10%">
                                                            <div className="paddingcenter8"><span
                                                                className="subtitle-table"><strong>Please</strong></span>
                                                            </div>
                                                        </td>

                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="45%">
                                                            <ul className="greenbullet-list">
                                                                <li> Resolves conflicts in the team</li>
                                                                <li> Will help others to please or impress</li>
                                                                <li> Responds to recognition or
                                                                    acknowledgement
                                                                </li>
                                                                <li className="list-bottom-pad">Takes others’
                                                                    comments very much to heart
                                                                </li>

                                                            </ul>
                                                            <p>Take the time to recognise/reward achievements
                                                                and good work.</p>

                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="45%">
                                                            <ul className="greenbullet-list">
                                                                <li>Does not mind upsetting people to ensure
                                                                    tasks completed
                                                                </li>
                                                                <li>Tolerates criticism and constructive
                                                                    feedback
                                                                </li>
                                                                <li className="list-bottom-pad"> Not bothered
                                                                    about making good impressions
                                                                </li>


                                                            </ul>
                                                            <p>Gently advise them to take care not to upset
                                                                others in the team, and give them a more
                                                                autonomous role in it.</p>

                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="center"
                                                            width="10%">
                                                            <div className="paddingcenter3"><span
                                                                className="subtitle-table"><strong>Belong</strong></span>
                                                            </div>
                                                        </td>

                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="45%">
                                                            <ul className="greenbullet-list">
                                                                <li>Sociable, outgoing and talkative</li>
                                                                <li> Brings people together</li>
                                                                <li> Can modify their behaviour with different
                                                                    people
                                                                </li>
                                                                <li className="list-bottom-pad">Avoids conflict
                                                                    with colleagues
                                                                </li>

                                                            </ul>
                                                            <p>Use these people to bring the team together. You
                                                                could allocate them a co-ordination role in the
                                                                team. Ensure that they have contact with
                                                                people.</p>

                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="45%">
                                                            <ul className="greenbullet-list">
                                                                <li>Able to work on their own</li>
                                                                <li> Will challenge others in team</li>
                                                                <li>Tends to take their own approach</li>
                                                                <li className="list-bottom-pad">Generates ideas
                                                                    and completes task rather than work with
                                                                    people
                                                                </li>

                                                            </ul>
                                                            <p>Give these people work to do and involve them in
                                                                idea generation or strategy. Focus their
                                                                questioning and challenge constructively.</p>

                                                        </td>

                                                    </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="mobile ipad-portrait-hide">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">


                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Motivational
                                                            area
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Achieve</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">High (4-5)</td>
                                                        <td valign="top">
                                                            <ul className="greenbullet-list">
                                                                <li>High sense of urgency</li>
                                                                <li>May become frustrated and impatient</li>
                                                                <li> Likes to compete with others</li>
                                                                <li>Sets demanding targets for self and others
                                                                </li>
                                                                <li className="list-bottom-pad"> Doesn’t take
                                                                    failure well
                                                                </li>
                                                            </ul>
                                                            <p>Consider setting them ambitious targets.
                                                                Encourage them to talk to you before they get
                                                                frustrated or irritated.</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">Low
                                                            (1-2)
                                                        </td>
                                                        <td valign="top" id="m-border-light">
                                                            <ul className="greenbullet-list">
                                                                <li>High sense of urgency</li>
                                                                <li>May become frustrated and impatient</li>
                                                                <li> Likes to compete with others</li>
                                                                <li>Sets demanding targets for self and others
                                                                </li>
                                                                <li className="list-bottom-pad"> Doesn’t take
                                                                    failure well
                                                                </li>
                                                            </ul>
                                                            <p>Consider setting them ambitious targets.
                                                                Encourage them to talk to you before they get
                                                                frustrated or irritated.</p>

                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Motivational
                                                            area
                                                        </th>
                                                        <td className=" green_curve1">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Please </strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">High (4-5)</td>
                                                        <td valign="top" className="darkgreen">
                                                            <ul className="greenbullet-list">
                                                                <li> Resolves conflicts in the team</li>
                                                                <li> Will help others to please or impress</li>
                                                                <li> Responds to recognition or
                                                                    acknowledgement
                                                                </li>
                                                                <li className="list-bottom-pad">Takes others’
                                                                    comments very much to heart
                                                                </li>

                                                            </ul>
                                                            <p>Take the time to recognise/reward achievements
                                                                and good work.</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">Low
                                                            (1-2)
                                                        </td>
                                                        <td valign="top" id="m-border-right">
                                                            <ul className="greenbullet-list">
                                                                <li>Does not mind upsetting people to ensure
                                                                    tasks completed
                                                                </li>
                                                                <li>Tolerates criticism and constructive
                                                                    feedback
                                                                </li>
                                                                <li className="list-bottom-pad"> Not bothered
                                                                    about making good impressions
                                                                </li>


                                                            </ul>
                                                            <p>Gently advise them to take care not to upset
                                                                others in the team, and give them a more
                                                                autonomous role in it.</p>

                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <th className="green_curve" width="50%">Motivational
                                                            area
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Belong</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">High (4-5)</td>
                                                        <td valign="top">
                                                            <ul className="greenbullet-list">
                                                                <li>Sociable, outgoing and talkative</li>
                                                                <li> Brings people together</li>
                                                                <li> Can modify their behaviour with different
                                                                    people
                                                                </li>
                                                                <li className="list-bottom-pad">Avoids conflict
                                                                    with colleagues
                                                                </li>

                                                            </ul>
                                                            <p>Use these people to bring the team together. You
                                                                could allocate them a co-ordination role in the
                                                                team. Ensure that they have contact with
                                                                people.</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">Low
                                                            (1-2)
                                                        </td>
                                                        <td valign="top" id="m-border-light">
                                                            <ul className="greenbullet-list">
                                                                <li>Able to work on their own</li>
                                                                <li> Will challenge others in team</li>
                                                                <li>Tends to take their own approach</li>
                                                                <li className="list-bottom-pad">Generates ideas
                                                                    and completes task rather than work with
                                                                    people
                                                                </li>

                                                            </ul>
                                                            <p>Give these people work to do and involve them in
                                                                idea generation or strategy. Focus their
                                                                questioning and challenge constructively.</p>

                                                        </td>
                                                    </tr>


                                                    </tbody>
                                                </table>

                                            </div>

                                            <div className="left-btn"><div onClick={this.props.handleChangePage('Page8')}
                                                                         className="button-next-previous-done">&lt;&lt; Previous </div>
                                            </div>
                                            <div className="right-btn"><div
                                                onClick={this.props.handleChangePage('Page10')}
                                                className="button-next-previous-done">Next &gt;&gt;</div></div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}